export const emptyRegistration = {
  registrationId: '',
  clientName: '',
  clientId: '',
  clientSecret: '',
  clientAuthenticationMethod: null,
  authorizationGrantType: null,
  redirectUri: '',
  scopes: null,
  providerDetails: {
    authorizationUri: '',
    tokenUri: '',
    userInfoEndpoint: {
      uri: '',
      authenticationMethod: null,
      userNameAttributeName: ''
    },
    jwkSetUri: '',
    issuerUri: ''
  }
}

export const proxyRegistration = {
  registrationId: '',
  clientName: '',
  clientId: '',
  clientSecret: '',
  clientAuthenticationMethod: null,
  authorizationGrantType: null,
  redirectUri: '',
  scopes: null,
  providerDetails: {
    authorizationUri: '',
    tokenUri: '',
    userInfoEndpoint: {
      uri: '',
      authenticationMethod: null,
      userNameAttributeName: ''
    },
    jwkSetUri: '',
    issuerUri: ''
  }
}

export const ltiRegistration = {
  registrationId: '',
  clientName: '',
  clientId: '',
  clientAuthenticationMethod: null,
  authorizationGrantType: 'implicit',
  redirectUri: '{baseUrl}/lti/login',
  scopes: ['openid'],
  providerDetails: {
    authorizationUri: '',
    tokenUri: '',
    jwkSetUri: ''
  }
}
